export default {
  primary: "#033A72 ",
  primary2: "#eb6f21",
};
